<template>
  <div class="flex full-width">
    <h2 class="filters-title">Status:</h2>
    <el-select
      v-model="receivableFiltersSelected"
      multiple
      :multiple-limit="filterLimit"
      placeholder="Select a status"
      @change="reloadList">
      <el-option-group
        v-for="group in receivableFilterOptions"
        :label="group.label"
        :key="group.label">
        <el-option
          v-for="item in group.options"
          :label="item.label"
          :value="item.value"
          :key="item.value"
          :disabled="item.disabled">
        </el-option>
      </el-option-group>
    </el-select>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      filterLimit: 3,
      receivableFilterOptions: [
        {
          label: 'Filter by Status',
          options: [
            {
              value: 'pending-confirmation',
              label: 'Pending Confirmation',
            },
            {
              value: 'pending',
              label: 'Pending',
            },
            {
              value: 'confirmed',
              label: 'Confirmed',
            },
          ],
        }
      ],
      receivableFiltersSelected: [],
    };
  },
  computed: {
    ...mapGetters({
      getReceivablesSelectedFilters: 'getReceivablesSelectedFilters',
    }),
  },
  mounted() {
    this.receivableFiltersSelected = this.getReceivablesSelectedFilters;
  },
  methods: {
    ...mapActions({
      setReceivablesSelectedFilters: 'setReceivablesSelectedFilters',
      getSearchedReceivableTransactionsData: 'getSearchedReceivableTransactionsData',
    }),
    reloadList() {
      const filterList = this.receivableFiltersSelected;
      window.setTimeout(() => {
        if (filterList === this.receivableFiltersSelected) {
          if (filterList.length > 0) {
            this.setReceivablesSelectedFilters(filterList);
          } else {
            this.setReceivablesSelectedFilters([]);
          }
          this.getSearchedReceivableTransactionsData();
        }
      }, 500);
    },
  },
};
</script>
<style lang="scss" >
.el-card__body {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
}
.el-select {
  flex: 2;
  padding-left: 10px;
  width: 100%;
}
.filters-title {
  margin: 0;
}
.full-width {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/receivables/partials/receivables-filters/partials/ReceivablesFilter.vue